module.exports = __webpack_public_path__ + "img/share-bg.4e1f1454.png";